"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function SvgComponent(props) {
    return React.createElement("svg", Object.assign({ viewBox: "0 0 512 512" }, props),
        React.createElement("line", { x1: 176, y1: 416, x2: 176, y2: 480, style: {
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 32
            } }),
        React.createElement("path", { d: "M80,32H272a32,32,0,0,1,32,32V476a4,4,0,0,1-4,4H48a0,0,0,0,1,0,0V64A32,32,0,0,1,80,32Z", style: {
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 32
            } }),
        React.createElement("path", { d: "M320,192H432a32,32,0,0,1,32,32V480a0,0,0,0,1,0,0H304a0,0,0,0,1,0,0V208A16,16,0,0,1,320,192Z", style: {
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 32
            } }),
        React.createElement("path", { d: "M98.08,431.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,431.87Z" }),
        React.createElement("path", { d: "M98.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,351.87Z" }),
        React.createElement("path", { d: "M98.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,271.87Z" }),
        React.createElement("path", { d: "M98.08,191.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,191.87Z" }),
        React.createElement("path", { d: "M98.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,98.08,111.87Z" }),
        React.createElement("path", { d: "M178.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,351.87Z" }),
        React.createElement("path", { d: "M178.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,271.87Z" }),
        React.createElement("path", { d: "M178.08,191.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,191.87Z" }),
        React.createElement("path", { d: "M178.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,178.08,111.87Z" }),
        React.createElement("path", { d: "M258.08,431.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,431.87Z" }),
        React.createElement("path", { d: "M258.08,351.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,351.87Z" }),
        React.createElement("path", { d: "M258.08,271.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,271.87Z" }),
        React.createElement("ellipse", { cx: 256, cy: 176, rx: 15.95, ry: 16.03, transform: "translate(-49.47 232.56) rotate(-45)" }),
        React.createElement("path", { d: "M258.08,111.87a16,16,0,1,1,13.79-13.79A16,16,0,0,1,258.08,111.87Z" }),
        React.createElement("path", { d: "M400,400a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
        React.createElement("path", { d: "M400,320a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
        React.createElement("path", { d: "M400,240a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
        React.createElement("path", { d: "M336,400a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
        React.createElement("path", { d: "M336,320a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
        React.createElement("path", { d: "M336,240a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }));
}
exports.default = SvgComponent;
